/**
 * Centralized image paths for the Flexcrete website
 * All image paths are organized by category for easy maintenance
 */

// Product Images - from /public/assets/Product Images/
export const productImages = {
  // Mixing & Preparation
  mixingSetup: '/assets/Product Images/Mixing Setup.png',
  mixingDemonstration: '/assets/Product Images/Mixing demonstration.png',
  consistencyGuide: '/assets/Product Images/Consistency guide.png',
  
  // Application Methods
  rollerMethod: '/assets/Product Images/Roller Method.png',
  trowelMethod: '/assets/Product Images/Trowel method.png',
  applicationPhoto: '/assets/Product Images/Application photo.png',
  surfacePreparation: '/assets/Product Images/Surface Preparation.png',
  
  // Flashing
  flashingPreparation: '/assets/Product Images/Flashing Preparation.png',
  flashingApplication: '/assets/Product Images/Flashing application.png',
  beforeFlashing: '/assets/Product Images/Before Flashing.png',
  afterFlashing: '/assets/Product Images/After Flashing.png',
  roofFlashing: '/assets/Product Images/Roof Flashing.png',
  balconyWaterproofing: '/assets/Product Images/Balcony Waterproofing.png',
  
  // Technical & Testing
  adhesionTesting: '/assets/Product Images/Adhesion Testing.png',
  chemicalTesting: '/assets/Product Images/Chemical Testing.png',
  compatibilityChart: '/assets/Product Images/Compatibility Chart.png',
  
  // Coverage & Guides
  coverageGuide: '/assets/Product Images/Coverage guide.png',
  
  // General
  waterarmor1: '/assets/waterarmor1.png',
  waterarmor: '/assets/waterarmor.jpg',
};

// Gallery Images - from /public/assets/Gallery/
export const galleryImages = {
  // Below Grade
  basementMoistureProtection: '/assets/Gallery/BAsement Moisture Protection.png',
  foundationWaterproofing: '/assets/Gallery/Foundation Waterproofing.png',
  cisternWaterproofing: '/assets/Gallery/Cistern Waterproofing.png',
  
  // Above Grade
  completeRoofWaterproofing: '/assets/Gallery/Complete Roof Waterproofing.png',
  balconyDeckWaterproofing: '/assets/Gallery/Balcony & Deck Waterproofing.png',
  facadeWaterproofing: '/assets/Gallery/Facade Waterproofing.png',
  retainingWallWaterproofing: '/assets/Gallery/Retaining Wall Waterproofing.png',
  planterWaterproofing: '/assets/Gallery/Planter Waterproofing.png',
  
  // Submerged
  completePoolWaterproofing: '/assets/Gallery/Complate Pool Waterproofing.png',
  spaWaterproofingRepair: '/assets/Gallery/Spa Waterproofing & Repair.png',
  fountainWaterproofing: '/assets/Gallery/Fountain Waterproofing.png',
  
  // Interior
  showerPanWaterproofing: '/assets/Gallery/Shower Pan Waterproofing.png',
};

// Helper function to get image path by name (case-insensitive)
export const getImagePath = (imageName: string, category: 'product' | 'gallery' = 'product'): string => {
  const normalizedName = imageName.toLowerCase().replace(/\s+/g, '');
  
  if (category === 'product') {
    const productMap: Record<string, string> = {
      'mixingsetup': productImages.mixingSetup,
      'mixingdemonstration': productImages.mixingDemonstration,
      'consistencyguide': productImages.consistencyGuide,
      'rollermethod': productImages.rollerMethod,
      'trowelmethod': productImages.trowelMethod,
      'applicationphoto': productImages.applicationPhoto,
      'surfacepreparation': productImages.surfacePreparation,
      'flashingpreparation': productImages.flashingPreparation,
      'flashingapplication': productImages.flashingApplication,
      'beforeflashing': productImages.beforeFlashing,
      'afterflashing': productImages.afterFlashing,
      'roofflashing': productImages.roofFlashing,
      'balconywaterproofing': productImages.balconyWaterproofing,
      'adhesiontesting': productImages.adhesionTesting,
      'chemicaltesting': productImages.chemicalTesting,
      'compatibilitychart': productImages.compatibilityChart,
      'coverageguide': productImages.coverageGuide,
      'waterarmor1': productImages.waterarmor1,
      'waterarmor': productImages.waterarmor,
    };
    return productMap[normalizedName] || productImages.waterarmor1;
  } else {
    const galleryMap: Record<string, string> = {
      'basementmoistureprotection': galleryImages.basementMoistureProtection,
      'foundationwaterproofing': galleryImages.foundationWaterproofing,
      'cisternwaterproofing': galleryImages.cisternWaterproofing,
      'completeroofwaterproofing': galleryImages.completeRoofWaterproofing,
      'balconydeckwaterproofing': galleryImages.balconyDeckWaterproofing,
      'facedewaterproofing': galleryImages.facadeWaterproofing,
      'retainingwallwaterproofing': galleryImages.retainingWallWaterproofing,
      'planterwaterproofing': galleryImages.planterWaterproofing,
      'completepoolwaterproofing': galleryImages.completePoolWaterproofing,
      'spawaterproofingrepair': galleryImages.spaWaterproofingRepair,
      'fountainwaterproofing': galleryImages.fountainWaterproofing,
      'showerpanwaterproofing': galleryImages.showerPanWaterproofing,
    };
    return galleryMap[normalizedName] || galleryImages.basementMoistureProtection;
  }
};
